import {JSX, useMemo} from "react";
import {Avatar, ListItem, ListItemText, Typography} from "@mui/material";
import {Invitation} from "../../../../api-client/EventerConsoleApiClient.ts";
import DialogActionButton from "../../../../../appfw/ui/dialogs/DialogActionButton.tsx";
import {RemoveCircle} from "@mui/icons-material";
import {InvitationsController} from "./Invitations.tsx";
import {formatDateTime} from "@eventer/api-client";
import {stringAvatar} from "../../../../../appfw/users/UserUtil.ts";

interface InvitationItemProps {
    readonly invitationsController: InvitationsController;
    readonly invitation: Invitation;
}

export default function InvitationItem(props: InvitationItemProps): JSX.Element {

    return useMemo(() =>
        (
            <ListItem
                secondaryAction={
                    (
                        <DialogActionButton
                            outlet={<RemoveCircle/>}
                            dialogTitle={"Einladung zurücknehmen"}
                            dialogContent={`Möchten Sie die Einladung an ${props.invitation.email} wirklich zurücknehmen?`}
                            dialogActions={[
                                {label: "Nein"},
                                {label: "Ja", action: () => props.invitationsController.remove(props.invitation.id)},
                            ]}
                        />
                    )
                }>
                <Avatar alt={props.invitation.email} {...stringAvatar(props.invitation.email)}/>
                <ListItemText sx={{marginLeft: 1}}
                              primary={
                                  <>
                                      {props.invitation.email}
                                  </>
                              }
                              secondary={
                                  <Typography component="span" variant="body2">
                                      {formatDateTime({date: new Date(props.invitation.invitedDate)})}
                                  </Typography>
                              }
                />
            </ListItem>
        ), [props]
    )
}